import fileApi from '@/api/file.api'


const state = {
}


const getters = {
}


const actions = {
  async loadFiles ({ rootState }, { projectId, fileType }) {
    const response = await fileApi.getFiles(rootState.tenant.current, projectId, fileType)
    return response.data
  },

  async loadRelations ({ commit, rootState }, id) {
    const response = await fileApi.getRelations(rootState.tenant.current, id)
    return response.data
  },

  async uploadFile ({ rootState }, { projectId, file, fileType }) {
    const response = await fileApi.uploadFile(rootState.tenant.current, projectId, fileType, file)
    return response.data
  }
}


const mutations = {
}


export default {
  state,
  getters,
  actions,
  mutations
}
